/** 数値を3桁ごと , 区切りにする */
export function groupDigits(n: number) {
  return n.toLocaleString('ja-JP')
}

if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest

  describe('groupDigits', () => {
    test('3桁ごとに区切る', () => {
      expect(groupDigits(123456789)).toBe('123,456,789')
    })
  })
}
